/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_ThinkingInputs */



/**
* | output |
* | --- |
* | "Thinking..." |
*
* @param {Assistant_ThinkingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_thinking = /** @type {((inputs?: Assistant_ThinkingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_ThinkingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pensée...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Denken...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pensiero...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Размышления...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pensamiento...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("思维...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("考え...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सोच...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pensamento...")
	return /** @type {LocalizedString} */ ("Thinking...")
});